<template>
  <div class="remove-predicted-wo-actual">
    <colored-line-popup :class="coloredLinePopupVariant" :close-action="closeAction">

      <template v-slot:top-content>
        <div class="title" :class="transactionCategoryClass">
          <span class="name">צפי {{transactionType}} קבועה</span>
          • <span class="category">{{ predictedTransaction.expense }}</span>
        </div>
        <transaction-amount :amount="predictedTransaction.predictedAmount" :class="transactionCategoryClass"/>
        <prediction-details :predicted-transaction="predictedTransaction" />
      </template>
      <template v-slot:footer>
        <div class="cancel" v-on:click="onCancelPredictedTransaction">
          <img class="trash" :src="require('@/assets/icons/blacktrash.svg')">
          <span class="text">מחיקת צפי {{transactionType}}</span>
        </div>
      </template>

    </colored-line-popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../../Segment';
import TransactionAmount from '../TransactionAmount.vue';
import PredictionDetails from '../PredictionDetails.vue';

const INCOME_TEXT = 'הכנסה';
const EXPENSE_TEXT = 'הוצאה';

export default {
  name: 'RemovePredictedWOActual',
  components: {
    ColoredLinePopup: BaseUI.ColoredLinePopup,
    TransactionAmount,
    PredictionDetails,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    nextAction: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserInteraction('RemovePredictedWOActual_Shown', {
      predictedTransaction: this.predictedTransaction,
    });
  },
  computed: {
    coloredLinePopupVariant() {
      return this.isIncomeTransaction ? 'success' : 'danger';
    },
    transactionCategoryClass() {
      return this.isIncomeTransaction ? 'income' : 'fixed';
    },
    isIncomeTransaction() {
      return this.predictedTransaction.isIncome;
    },
    transactionType() {
      return this.isIncomeTransaction ? INCOME_TEXT : EXPENSE_TEXT;
    },
  },
  methods: {
    onCancelPredictedTransaction() {
      Segment.trackUserInteraction('RemovePredictedWOActual_CancelPredictionClicked', {
        predictedTransaction: this.predictedTransaction,
      });
      this.nextAction();
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../../scss/category-color-mixins';

  .remove-predicted-wo-actual {
    text-align: right;

    .title {
      font-weight: bold;
      margin-bottom: 24px;
      line-height: 10px;
      @include category-color;

      .category {
        font-weight: normal;
      }
    }

    .transaction-amount {
      margin-bottom: 12px;
    }

    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: $riseup_black;
      cursor: pointer;

      .trash {
        margin-left: 3px;
        height: 16px;
      }

      .text {
        text-decoration: underline;
      }
    }
  }

</style>
